'use client'

import { useState, useEffect } from 'react';
import Image from 'next/image';

const DynamicImageV2 = ({ src, alt, name, width = 500, height = 500, className = '' }) => {
    return (
        <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            className={className}
        />
    )
};

export default DynamicImageV2;
